<template>
  <transition name="fade">
    <div v-if="visible" class="wave-container" :class="containerClass">
      <svg viewBox="0 24 150 28" preserveAspectRatio="none" style="height: 100%; width: 100%;">
        <defs>
          <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"></path>
        </defs>
        <g class="parallax">
          <use xlink:href="#gentle-wave" x="48" y="0" :fill="waveColors.layer1"></use>
          <use xlink:href="#gentle-wave" x="48" y="3" :fill="waveColors.layer2"></use>
          <use xlink:href="#gentle-wave" x="48" y="5" :fill="waveColors.layer3"></use>
          <use xlink:href="#gentle-wave" x="48" y="7" :fill="waveColors.layer4" :opacity="bottomOpacity"></use>
        </g>
      </svg>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'WaveAnimation',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    containerClass: {
      type: String,
      default: ''
    },
    waveColors: {
      type: Object,
      default: () => ({
        layer1: 'rgba(255,255,255,0.4)',
        layer2: 'rgba(255,255,255,0.25)', 
        layer3: 'rgba(255,255,255,0.1)',
        layer4: '#1d1e26'
      })
    },
    bottomOpacity: {
      type: Number,
      default: 0.85
    },
    animationSpeed: {
      type: Number,
      default: 1
    }
  },  computed: {
    animationStyles() {
      const baseSpeed = this.animationSpeed;
      return {
        '--base-duration': `${25 / baseSpeed}s`,
        '--layer1-duration': `${7 / baseSpeed}s`,
        '--layer2-duration': `${10 / baseSpeed}s`, 
        '--layer3-duration': `${13 / baseSpeed}s`,
        '--layer4-duration': `${20 / baseSpeed}s`
      };
    }
  },
  mounted() {
    if (this.animationSpeed !== 1) {
      this.applyCustomAnimationSpeeds();
    }
  },
  methods: {
    applyCustomAnimationSpeeds() {
      const waveContainer = this.$el.querySelector('.wave-container');
      if (waveContainer) {
        Object.entries(this.animationStyles).forEach(([property, value]) => {
          waveContainer.style.setProperty(property, value);
        });
      }
    }
  }
};
</script>

<style scoped>
.wave-container {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 33vh;
  overflow: hidden;
  z-index: -10;

  @media (max-width: 768px) {
    width: 250%;
  }
}

.parallax > use {
  animation: moveForever var(--base-duration, 25s) cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite;
}

.parallax > use:nth-child(1) {
  animation-delay: -2s;
  animation-duration: var(--layer1-duration, 7s);
}

.parallax > use:nth-child(2) {
  animation-delay: -3s;
  animation-duration: var(--layer2-duration, 10s);
}

.parallax > use:nth-child(3) {
  animation-delay: -4s;
  animation-duration: var(--layer3-duration, 13s);
}

.parallax > use:nth-child(4) {
  animation-delay: -5s;
  animation-duration: var(--layer4-duration, 20s);
}

@keyframes moveForever {
  0% {
    transform: translate3d(-90px, 0, 0);
  }
  100% {
    transform: translate3d(85px, 0, 0);
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
